import { TripContext } from 'contexts'
import { useContext } from 'react'
import { useStopService } from 'services'
import { Company, LineItem, Signature, Stop, SyncStatus, TrailerLocation, Trip } from 'services/types'
import { TripStatus } from './enums'
import { useLineItemService } from './useLineItemService'

export const useTripService = () => {

    const { deleteStops } = useStopService()
    const { deleteLineItems } = useLineItemService()

    const tripContext = useContext(TripContext)

    const updateTrailerPadLocation = (tripId: number, location: TrailerLocation): Trip | undefined => {
        let trip: Trip | undefined = tripContext.trips.find(t => t.id == tripId)
        if (trip && (location.locationCode?.length > 0 || location.trailerNumber?.length > 0)) {
            trip.trailerLocation = location
            tripContext.trips.put(trip)
        }
        return trip
    }

    const deleteTrip = (tripId: number): void => {
        const stops: Stop[] = tripContext.stops.filter(stop => stop.tripId === tripId)
        tripContext.trips.remove(tripId),
        deleteStops(stops.map(stop => stop.id))

        const staleLineItems: LineItem[] = tripContext.lineItems.filter(item => !tripContext.orderItems.some(orderItem => orderItem.lineItemId === item.id) && !tripContext.returnItems.some(returnItem => returnItem.lineItemId === item.id))
        const staleCompanies: Company[] = tripContext.companies.filter(company => !tripContext.stops.some(stop => stop.companyId?.toString() === company.id))
        const staleSignatures: Signature[] = tripContext.signatures.filter(signature => !tripContext.orders.some(order => order.signatureId === signature.id))

        deleteLineItems(staleLineItems.map(lineItem => lineItem.id)),
        tripContext.companies.bulkRemove(staleCompanies.map(company => company.id)),
        tripContext.signatures.bulkRemove(staleSignatures.map(signature => signature.id))
    }

    const clearTrips = (): void => {
        tripContext.trips.map(trip => deleteTrip(trip.id))
    }

    const updateTripStatus = async (tripId: number, status: TripStatus): Promise<void> => {
        let trip: Trip | undefined = tripContext.trips.find(t => t.id === tripId)
        if (trip) {
            trip.status = status
            await tripContext.trips.put(trip)
        }
    }

    const isTripSynced = (tripId: number): Boolean => {
        const stops: Stop[] =  tripContext.stops.filter(s => s.tripId == tripId)
        const stopsNotSynced: SyncStatus[] = tripContext.syncStatus.filter(s => stops.some(stop => stop.id == s.id))
        return stopsNotSynced.length == 0 ? true : false
    }

    return {
        updateTrailerPadLocation: updateTrailerPadLocation,
        deleteTrip: deleteTrip,
        clearTrips: clearTrips,
        updateTripStatus: updateTripStatus,
        isTripSynced: isTripSynced
    }

}